export const AVATARS = [
  "🎩","🌸","🔥","⚡","🎯","💎","🦊","🌟",
  "🐎","🍀","🎪","🦁","🌊","🎸","🏄","🚀",
];

export const GROUP_COLOURS = [
  { key: "teal", label: "Teal", hex: "#0c8599" },
  { key: "blue", label: "Blue", hex: "#1971c2" },
  { key: "green", label: "Green", hex: "#2f9e44" },
  { key: "gold", label: "Gold", hex: "#c07800" },
  { key: "red", label: "Red", hex: "#c92a2a" },
  { key: "purple", label: "Purple", hex: "#6741d9" },
];

export const colourHex = (key) => {
  const found = GROUP_COLOURS.find((c) => c.key === key);
  return found ? found.hex : "#1971c2";
};

// 12 distinct silk swatches, cycled by (horse_number - 1) % 12
export const SILK_COLOURS = [
  "#c92a2a", "#1971c2", "#2f9e44", "#c07800",
  "#6741d9", "#e64980", "#f59f00", "#0c8599",
  "#495057", "#212529", "#00a884", "#ff922b",
];

export const ALL_TRACKS = [
  "Flemington", "Randwick", "Caulfield", "Moonee Valley", "Sandown",
  "Rosehill", "Doomben", "Eagle Farm", "Morphettville", "Ascot (Perth)",
  "Mornington", "Ballarat", "Bendigo", "Gosford", "Hawkesbury",
  "Warwick Farm", "Ipswich", "Sunshine Coast", "Gold Coast", "Kembla Grange",
];

export const RACE_NUMBERS_ALL = Array.from({ length: 10 }, (_, i) => i + 1);
